import axios from '@/services/axios'
import appsettings from '@/appsettings'

export async function getAvailableCredit() {
  if (appsettings.apiDebugMessages) console.log('agentCreditApi.getAvailableCredit.request')
  const response = await axios().get('/agentcredit')
  if (appsettings.apiDebugMessages) console.log('agentCreditApi.getAvailableCredit.response', response)
  return response.data
}